/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateWhatsAppMessageReadByDataSchema = z.object({
	userId: z.string(),
	readAt: z.iso.datetime(),
})

export type CandidateWhatsAppMessageReadByDataSchema = z.infer<typeof candidateWhatsAppMessageReadByDataSchema>
